module.exports = __webpack_public_path__ + "static/media/rowaak.b6bf2f60.webp";